import * as playingCards from "../playing-cards";
import * as React from "react";

export const cardImages = {
    '10C': require('../images/10C.svg'),
    '10D': require('../images/10D.svg'),
    '10H': require('../images/10H.svg'),
    '10S': require('../images/10S.svg'),
    '11C': require('../images/11C.svg'),
    '11D': require('../images/11D.svg'),
    '11H': require('../images/11H.svg'),
    '11S': require('../images/11S.svg'),
    '12C': require('../images/12C.svg'),
    '12D': require('../images/12D.svg'),
    '12H': require('../images/12H.svg'),
    '12S': require('../images/12S.svg'),
    '13C': require('../images/13C.svg'),
    '13D': require('../images/13D.svg'),
    '13H': require('../images/13H.svg'),
    '13S': require('../images/13S.svg'),
    '1C': require('../images/14C.svg'),
    '1D': require('../images/14D.svg'),
    '1H': require('../images/14H.svg'),
    '1S': require('../images/14S.svg'),
    '2C': require('../images/2C.svg'),
    '2D': require('../images/2D.svg'),
    '2H': require('../images/2H.svg'),
    '2S': require('../images/2S.svg'),
    '3C': require('../images/3C.svg'),
    '3D': require('../images/3D.svg'),
    '3H': require('../images/3H.svg'),
    '3S': require('../images/3S.svg'),
    '4C': require('../images/4C.svg'),
    '4D': require('../images/4D.svg'),
    '4H': require('../images/4H.svg'),
    '4S': require('../images/4S.svg'),
    '5C': require('../images/5C.svg'),
    '5D': require('../images/5D.svg'),
    '5H': require('../images/5H.svg'),
    '5S': require('../images/5S.svg'),
    '6C': require('../images/6C.svg'),
    '6D': require('../images/6D.svg'),
    '6H': require('../images/6H.svg'),
    '6S': require('../images/6S.svg'),
    '7C': require('../images/7C.svg'),
    '7D': require('../images/7D.svg'),
    '7H': require('../images/7H.svg'),
    '7S': require('../images/7S.svg'),
    '8C': require('../images/8C.svg'),
    '8D': require('../images/8D.svg'),
    '8H': require('../images/8H.svg'),
    '8S': require('../images/8S.svg'),
    '9C': require('../images/9C.svg'),
    '9D': require('../images/9D.svg'),
    '9H': require('../images/9H.svg'),
    '9S': require('../images/9S.svg'),
    '0J': require('../images/Joker1.svg'),
    '1J': require('../images/Joker2.svg'),
    'back': require('../images/card-back.svg'),
}

export interface ICardProps {
    className: string;
    player?: number;
    i?: number;
    used?: boolean;
    faceUp?: boolean;
    enabled?: boolean;
    left?: number;
    onClick?: (cardIndex: number) => void;
}

export class CardComponent extends React.Component<playingCards.Card & ICardProps> {

    public render () {
        const enabled = (this.props.faceUp && this.props.player === 1 && this.props.enabled)
            ? 'enabled'
            : '';

        const onClick = this.props.onClick && this.props.onClick.bind(undefined, this.props.i) || undefined;

        let className = this.props.className;
        let style: any = {};

        if (this.props.discardIndex !== undefined) {
            className += " discard-pile";

            if (className.indexOf("end-of-round") === -1) {
                style.zIndex = 30 + this.props.discardIndex;
            }
        }

        if (this.props.used) {
            className += " blur-card"
        }

        return (
            <span
                style={style}
                className={`
                    card
                    ${enabled}
                    ${className}
                    i-${this.props.i}
                    ${this.props.faceUp ? 'face-up' : 'face-down'}
                `}
                onClick={onClick}
            >
                <img src={cardImages[`${this.props.number}${this.props.suit}`]} className="img-face-up" alt="face-up" />
                <img src={cardImages.back} className="img-face-down" alt="face-down" />
            </span>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/CardComponent.tsx